import { LoginService } from './login.service';
import { PlanMainService } from './../plan/service/plan-main.service';
import { Observable, Subject, Subscription } from 'rxjs/Rx';
import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import {
  CanActivate,
  CanActivateChild,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  Route
} from '@angular/router';
import { Http } from '@angular/http';
import { filter, map, tap } from 'rxjs/operators';
import { DataService } from './data.service';


@Injectable()
export class AuthGuardMenu implements CanActivate, CanActivateChild {

  static headers = new Headers({ 'Content-Type': 'application/json' });
  public staffSubScription: Subscription;
  public ngUnsubscribe = new Subject();
  public defaultHeaders: Headers = new Headers();
  public isMenuAutho;

  constructor(
    private router: Router,
    private planMainService: PlanMainService,
    private _data: DataService) { }


  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    const staffData = this._data.staffData;
    if (staffData) {
      return this.checkAuthority();
    } else {
      return true;
    }
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    return true;
  }

  checkAuthority() {
    if (this.planMainService.menuAutho.getValue() == null) {
      this.planMainService.getMenuAuthority().subscribe((res: any) => {
        if (res) {
          this.planMainService.setMenuAutho(res);
        }
      });
    }
    return this.planMainService.menuAutho.pipe(
      tap(res => console.log(res)),
      filter((res: any) => res),
      map((res: any) => {
        this.isMenuAutho = Object.values(res);
        if (this.isMenuAutho && this.isMenuAutho[4] && this.isMenuAutho[4].enabled === 1) {
          return true;
        } else {
          return false;
        }
      })
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/services/auth-guard-menu.service.ts